export type StoreHours = {
  wdOpenAt: string
  wdCloseAt: string
  weOpenAt: string
  weCloseAt: string
  openHours: string
  holiday: string
  monOpenAt: string
  monCloseAt: string
  tueOpenAt: string
  tueCloseAt: string
  wedOpenAt: string
  wedCloseAt: string
  thuOpenAt: string
  thuCloseAt: string
  friOpenAt: string
  friCloseAt: string
  satOpenAt: string
  satCloseAt: string
  sunOpenAt: string
  sunCloseAt: string
  holOpenAt: string
  holCloseAt: string
}

export type StoreLocation = {
  lat: string
  lon: string
  address: string
  distance: string
  countryNameShort: string
  postcode: string
  area0Code: number
  area0Name: string
  area1Code: number
  area1Name: string
  municipality: string
  number: string
  building: string
  phone: string
}

export enum FilterParams {
  storeItem = 'productType',
  storeType = 'storeType',
  storeService = 'storeService',
  accessibility = 'accessibility',
}

export enum MapFilterToQueryParamKey {
  product = 'product',
  services = 'services',
  accessibility = 'accessibility',
}

export enum UrlQueryParamValue {
  product = 'product_type',
  services = 'services_type',
  accessibility = 'accessibility',
}

export type StoreFilter = {
  code: string
  filterParam: FilterParams
  storeFlag?: string
}

export type FilterGroup = { [filterId: string]: boolean }

export type StoreFiltersState = {
  activeFiltersOrder: Array<{ [key: string]: string | boolean }>
  storeSize: Components.Parameters.StoreType | ''
  men: boolean
  baby: boolean
  kids: boolean
  maternity: boolean
  parking: boolean
  wheelchairAccessibleParking: boolean
  teen: boolean
  openFrontInner: boolean
  uniqloFlower: boolean
  utMe: boolean
  reUniqloStudio: boolean
  customOrderMen: boolean
  customOrderWomen: boolean
  areaCode?: string
  women?: string
}

export type StoreImages = { url: string; width: number; height: number }

export type StoreCategory = { name: string }

export type StoreVitals = {
  storeId: number
  storeName: string
  g1ImsStoreId4: string
  g1ImsStoreId6: string
  g1ImsStoreId13: string
  typeCode: number
  busAccess: string
  carAccess: string
  trainAccess: string
  url: string
  deliveryFlg: number
  clickAndCollectFlg: number
  announcement: string
  storeImages: Array<StoreImages>
  categoryLabel: Array<StoreCategory>
  kidsFlag: number
  babyFlag: number
  floorMapFlg: number
  inventoryFlg: number
  openDate: string
  parkingFlg: number
  womenFlg: number
  menFlg: number
  myStoreFlag: number
  storeInvPurchaseFlg: number
}

export type Store = StoreHours & StoreLocation & StoreVitals

export type Area = {
  area1Code: number
  area1Name: string
}
